import SubMenu from "./subMenu";
import { RiArrowDownSLine } from "react-icons/ri";
import { RiArrowDropUpLine } from "react-icons/ri";

import { BiWorld } from "react-icons/bi";
import { BsLightningCharge } from "react-icons/bs";
import MenuIcon from "./MenuIcon";

function desktopMenu({ index_menu, fast_menu, lang_menu, lang }) {
	return (
		<div class="grid grid-cols-6 items-center justify-between gap-12  ">
			<nav className={` ease-in transform transition-transform col-span-4`}>
				<ul class="flex items-center  font-semibold">
					{index_menu.menus.map((item, index) => (
						<li
							class="relative group px-3 py-2   cursor-pointer   "
							key={index}
						>
							<div class="group-hover:opacity-50 -translate-y-0 transition  group-hover:translate-y-1 ">
								{item.link_type === "text_link" ? (
									<MenuIcon
										sub={item.sub}
										title={item.title}
										link={item.link_data.link}
									/>
								) : (
									<MenuIcon sub={item.sub} title={item.title} />
								)}
							</div>
							{item.sub && <SubMenu lang={lang} data={item.sub} />}
						</li>
					))}
				</ul>
			</nav>
			<nav className="  flex justify-end col-span-2   text-white text-sm ">
				<div className=" h-12 flex justify-center items-center   ">
					{fast_menu.menus && (
						<div
							className={`  ease-in transform transition-transform    bg-gray-500 min-w-24  group  flex gap-12 px-4 py-2  rtl:rounded-r-md rtl:rounded-l-none ltr:rounded-l-md ltr:rounded-r-none shadow-xl`}
						>
							<div className=" cursor-pointer  flex items-center gap-2">
								<BsLightningCharge />
								{fast_menu.data.title}
							</div>
							<div className="absolute  rtl:right-0  ltr:left-0   top-4   translate-x-0  min-w-28  transition group-hover:translate-y-5 translate-y-0 opacity-0 invisible group-hover:opacity-100 group-hover:visible duration-500 ease-in-out group-hover:transform z-50 transform">
								<div className=" py-1 flex gap-1 flex-col ">
									<div className=" bg-gray-500 flex flex-col  min-w-44  divide-y-[1px] divide-white/50  rounded-md px-2">
										{fast_menu.menus.map(
											(item, index) =>
												item.link_data.link && (
													<a
														key={index}
														className="text-white py-2 "
														href={item.link_data.link}
														target={
															item.link_data.new_window ? "_blank" : undefined
														}
													>
														<div className=" text-white  "></div>
														{item.title}
													</a>
												),
										)}
									</div>
								</div>
							</div>
						</div>
					)}
					<div
						className={` ease-in transform transition-transform  group relative bg-shirinmehr-dark1 cursor-pointer   min-w-32 py-2   text-white rtl:rounded-l-md ltr:rounded-r	-md  px-4 flex items-center shadow-xl`}
					>
						{lang_menu.menus.map((item) => {
							return (
								item.code === lang && (
									<div className=" flex items-center gap-2 justify-center   w-full">
										<BiWorld />
										<div>{item.title}</div>
									</div>
								)
							);
						})}
						<div className="absolute  py-1   left-0 top-4   translate-x-0  min-w-28  transition group-hover:translate-y-5 translate-y-0 opacity-0 invisible group-hover:opacity-100 group-hover:visible duration-500 ease-in-out group-hover:transform z-50 transform">
							{lang_menu.menus.map((item) => {
								return (
									item.code !== lang && (
										<div className=" py-1">
											<div className="bg-shirinmehr-dark1    min-w-32  rounded-md text-white p-2  text-center ">
												<a
													className="  text-white border-none "
													href={item.link_data.link}
												>
													{item.subTitle}
												</a>
											</div>
										</div>
									)
								);
							})}
						</div>
					</div>
				</div>
			</nav>
		</div>
	);
}

export default desktopMenu;
